import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router';
import { useLocalize } from '@hooks/use-localize';
import { useShell } from '@/context/shell-context';
import { useOptionalSession } from '@hooks/security/use-session';
import type { TDashWorkflow } from '@/context/shell-context';
import LayoutMain from '@components/chrome/layout-main';
import NkrChrome from '@components/chrome/nkr-chrome';
import PlChrome from '@components/chrome/pl-chrome';

interface ILayoutProps {
    workflow?: TDashWorkflow;
    showMentorButton?: boolean;
    hasMultipleLanguages?: boolean;
    languageData?: Record<string, string>;
    supportPhone?: string | null;
    centerName?: string;
    centerLogoUrl?: string | null;
    centerSiteUrl?: string | null;
    centerBackground?: string | null;
}

const Layout = (props: ILayoutProps) => {
    const shell = useShell();
    const session = useOptionalSession();

    const workflow = props.workflow ?? shell.workflow;
    const showMentorButton = props.showMentorButton ?? shell.showMentorButton;
    const hasMultipleLanguages = props.hasMultipleLanguages ?? shell.hasMultipleLanguages;
    const languageData = props.languageData ?? shell.languageData;
    const supportPhone = props.supportPhone ?? shell.supportPhone;
    const centerName = props.centerName ?? shell.centerName;
    const centerLogoUrl = props.centerLogoUrl ?? shell.centerLogoUrl;
    const centerSiteUrl = props.centerSiteUrl ?? shell.centerSiteUrl;
    const centerBackground = props.centerBackground ?? shell.centerBackground;
    const subDomain = shell.subdomain ?? '';

    const t = useLocalize(languageData);

    const { pathname } = useLocation();
    const isPrivateLabel = workflow === 'pl' || workflow === 'udash';

    const dashboardLink =
        session && !pathname.startsWith('/register/donate')
            ? '/register/donate'
            : null;

    useLayoutEffect(() => {
        document.body.classList.toggle('pl-dash', isPrivateLabel);

        return () => document.body.classList.remove('pl-dash');
    }, [isPrivateLabel]);

    if (isPrivateLabel) {
        return (
            <PlChrome
                t={t}
                hasMultipleLanguages={hasMultipleLanguages}
                dashboardLink={dashboardLink}
                centerName={centerName}
                centerLogoUrl={centerLogoUrl}
                centerSiteUrl={centerSiteUrl}
                centerBackground={centerBackground}
                subDomain={subDomain}
            >
                <LayoutMain containerClassName="container-fluid" mainClassName='pl-main' supportPhone={supportPhone} />
            </PlChrome>
        );
    }

    return (
        <NkrChrome
            t={t}
            showMentorButton={showMentorButton}
            hasMultipleLanguages={hasMultipleLanguages}
            dashboardLink={dashboardLink}
        >
            <LayoutMain containerClassName="container-fluid" mainClassName='nkr-main' supportPhone={supportPhone} />
        </NkrChrome>
    );
};

export default Layout;
